<template>
  <div class="header" v-if="page.home" :class="{ 'expanded': menuExpanded, 'reduced': reducedMenu}">
    <div class="header__inner">
      <div class="logo" @click="scrollToTop()" v-if="page.home.logo">
        <img :src="page.home.logo.img.$src" alt=""/>
      </div>
      <div class="burger" @click="expandMenu()">
        <span></span>
      </div>
      <div class="navigation-container">
        <div class="logo" @click="scrollToTop()" v-if="page.home.logo">
          <img :src="page.home.logo.img.$src" alt=""/>
        </div>
        <Navigation/>
        <span class="navigation__close" @click="expandMenu()">&times;</span>
      </div>
      <Langs/>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Navigation from '@/components/Navigation';
  import Langs from '@/components/Langs';

  export default {
    name: 'headerComponent',
    data() {
      return {
        reducedMenu: false,
      };
    },
    computed: mapGetters({
      page: 'page',
      menuExpanded: 'menuExpanded',
    }),
    components: {
      Navigation,
      Langs,
    },
    mounted() {
      window.addEventListener('scroll', this.reduceMenu);
    },
    methods: {
      expandMenu() {
        this.$store.commit('CHANGE_MENU_STATE', !this.menuExpanded);
      },
      reduceMenu() {
        const winCurrentTop = window.pageYOffset;
        if (winCurrentTop > 0 && !this.reducedMenu) {
          this.reducedMenu = true;
        }
        if (winCurrentTop === 0 && this.reducedMenu) {
          this.reducedMenu = false;
        }
      },
      scrollToTop() {
        this.$SmoothScroll(0, 500);
      },
    },
  };
</script>

<style>
  .header {
    z-index: 3;
    top: 0;
    left: 0;
    position: fixed;
    pointer-events: none;
    width: 100%;

    &:before {
      content: '';
      background: rgba(29,4,4,0.82);
      background: linear-gradient(to bottom, rgba(29,4,4,0.82) 0%, rgba(41, 10, 10, 0.4) 53%, rgba(0, 0, 0, 0.00) 88%);
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 230px;
      z-index: -1;
      transform: translate3d(0, 0, 0);
      transition: height 0.3s ease-in-out;
    }

    &__inner {
      padding: 20px 25px;
      max-width: 1400px;
      margin: 0 auto;
    }

    .logo {
      display: inline-block;
      vertical-align: middle;
      pointer-events: auto;
      position: relative;
      width: 95px;
      height: 116px;
      transform: translate3d(0, 0, 0);
      transition: width 0.3s ease-in-out, height 0.3s ease-in-out;

      img {
        max-width: 100%;
        height: auto;
        max-height: 100%;
      }
    }

    .burger {
      display: none;
      position: absolute;
      right: 25px;
      top: 25px;
      width: 27px;
      height: 22px;
      cursor: pointer;
      pointer-events: auto;

      span {
        position: absolute;
        left: 
      }

      &:before,
      &:after {
        content: '';
      }

      span,
      &:before,
      &:after {
        position: absolute;
        left: 0;
        right: 0;
        height: 2px;
        background: #fff;
      }

      span {
        top: 50%;
        margin-top: -1px;
      }

      &:before {
        top: 0;
      }

      &:after {
        bottom: 0;
      } 
    }

    &.reduced {
      &:before {
        height: 150px;
      }

      .logo {
        width: 70px;
        height: 85px;
        cursor: pointer;
      }
    }
  }

  .navigation {
    &-container {
      display: inline-block;
      vertical-align: middle;
      margin-left: 15px;
      pointer-events: auto;

      .logo {
        display: none;
        position: absolute !important;
        z-index: 1;
        top: 20px;
      }
    }

    &__close {
      display: none;
    }
  }

  @media (max-width: 1020px) {
    .navigation {
      &-container {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin-top: 0;
        overflow-y: auto; 
        padding: 180px 25px 50px 25px;
        margin-left: 0; 
        background: #680d07;
        background: linear-gradient(to bottom, #490905 0%, #680d07 100%);
      }

      &__close {
        display: block;
        position: absolute;
        right: 25px;
        top: 25px;
        font-size: 50px;
        cursor: pointer;
        transition: color 0.2s ease;

        &:hover {
          color: $main-color;
        }
      }
    }

    .header {
      /*position: relative;*/

      .langs {
        right: 90px !important;
      }

      .burger {
        display: block;
      }

      &.expanded {
        .navigation-container {
          display: block;

          .logo {
            display: block;
          }
        }
      }
    }
  }

  @media (max-width: 850px) {
    .navigation {
      &-container {
        padding-top: 120px;
      }
    }
    .header {
      /*position: relative;*/

      &:before {
        height: 130px;
      }

      .logo {
        width: 50px !important;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/HeaderComponent.vue?3420f43e